function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1498",
  d: "m 8.7174026,279.9786 h -5.375559 c -1.2747754,0 -2.3038109,1.02904 -2.3038109,2.30381 v 6.1435 c 0,1.27477 1.0290355,2.30381 2.3038109,2.30381 l -0.767937,0.76793 v 0.76794 h 0.767937 l 1.5358739,-1.55891 1.535874,0.023 v -3.83969 H 2.5739066 v -5.39091 l 6.911433,0.0154 v 1.53588 h 1.5358734 v -0.76794 c 0,-1.27477 -1.029035,-2.30381 -2.3038104,-2.30381 z m -5.375559,7.67937 c 0.4223653,0 0.767937,0.34557 0.767937,0.76794 0,0.42236 -0.3455717,0.76793 -0.767937,0.76793 -0.4223653,0 -0.767937,-0.34557 -0.767937,-0.76793 0,-0.42237 0.3455717,-0.76794 0.767937,-0.76794 z m 11.9567784,-3.33285 c -0.107511,-0.30717 -0.399327,-0.50684 -0.744898,-0.50684 H 9.0322568 c -0.3532513,0 -0.637388,0.19967 -0.7525785,0.50684 l -1.0981499,3.15622 0.00768,4.23134 c 0,0.29181 0.2380605,0.55291 0.5298765,0.55291 h 0.4761209 c 0.2918161,0 0.5221974,-0.29181 0.5221974,-0.58363 v -0.95224 h 6.1434958 v 0.95224 c 0,0.29182 0.238061,0.58363 0.529877,0.58363 h 0.468441 c 0.291816,0 0.529877,-0.2611 0.529877,-0.55291 l 0.0077,-1.05208 v -3.17926 z m -6.2663652,0.2611 h 5.5214672 l 0.790975,2.30381 H 8.2412814 Z m -0.3148542,4.60762 c -0.4223656,0 -0.7679372,-0.34557 -0.7679372,-0.76793 0,-0.42237 0.3455716,-0.76794 0.7679372,-0.76794 0.4223653,0 0.767937,0.34557 0.767937,0.76794 0,0.42236 -0.3455717,0.76793 -0.767937,0.76793 z m 6.1434954,0 c -0.422365,0 -0.767937,-0.34557 -0.767937,-0.76793 0,-0.42237 0.345572,-0.76794 0.767937,-0.76794 0.422366,0 0.767937,0.34557 0.767937,0.76794 0,0.42236 -0.345571,0.76793 -0.767937,0.76793 z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 21.134064,13.931019 c -1.329109,0 -2.574366,-0.66855 -3.262333,-1.796272 -0.687967,-1.127722 -0.687967,-2.5537068 0,-3.6814286 0.687967,-1.127722 1.933224,-1.796273 3.262333,-1.796273 v 2.140438 c -0.608762,0 -1.154601,0.309927 -1.435571,0.7704948 -0.280969,0.4605698 -0.280969,0.9915398 0,1.4521078 0.28097,0.460568 0.826809,0.770496 1.435571,0.770496 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 9.5216132e-7,
  y: 9.1767874,
  x: 16.407986,
  height: 2.0670574,
  width: 1.2246188,
  id: "rect962"
}));

var SvgCarcounter = function SvgCarcounter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarcounter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carcounter.98ba39be.svg";
export { ForwardRef as ReactComponent };